import { parse } from 'query-string';
import type { ThunkAction } from '../../types/app.types';
import { getAccountSummary } from './account-module';
import { addCoupon } from './cart-module';
import getCouponOrReferralCode from '../../utils/get-coupon-or-referral-code';

export function bootstrap(): ThunkAction<Promise<any>> {
  return function (dispatch, getState, { req, history }): Promise<any> {
    const bootPromises = [];
    const pathname = req ? req.url : history.location.pathname;
    const search = req ? req.query : parse(history.location.search);

    if (!getState().account.sessionId) {
      bootPromises.push(dispatch(getAccountSummary()));
    }

    const couponOrReferral = getCouponOrReferralCode(pathname, search);

    if (couponOrReferral) {
      bootPromises.push(dispatch(addCoupon(couponOrReferral)));
    }

    return Promise.all(bootPromises).catch((error) => {
      console.error(error);
      window.newrelic && window.newrelic.noticeError(error);
    });
  };
}
